<template>
    <a-card :bordered="false">
        <!-- 操作 -->
        <div class="table-operations">
            <a-button type="primary" @click="add()">
                <a-icon type="plus" />导入
            </a-button>
        </div>
        <!-- 数据展示 -->
        <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }"
            :pagination="false" :bordered="tableBordered" :customRow="customRow">
        </a-table>
    </a-card>
</template>
  
<script>
import {
    delPlaylistVideo,
    selectAllPlaylist,
    copyPlaylist
} from '@/api/video/video'
import { tableMixin } from '@/store/table-mixin'

export default {
    name: 'ImportPlaylist',
    props: {
        existingVideoIds: {
            type: Array,
            default: () => []
        },
        type: {
            type: Number,
            required: true
        },
        language: {
            type: String,
            required: true
        }
    },
    components: {
    },
    mounted() {
    },
    mixins: [tableMixin],
    data() {
        return {
            type: null,
            language: '',
            existingVideoIds: [],
            drawerVisible: false,
            modalTitle: '新增片单剧集',
            list: [],
            selectedRowKeys: [],
            selectedRows: [],
            // 高级搜索 展开/关闭
            advanced: false,
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            ids: [],
            loading: false,
            queryParam: {
            },
            columns: [
                {
                    title: '片单名称',
                    dataIndex: 'name',
                    ellipsis: true,
                    align: 'center'                        
                },
                {
                    title: '短剧数量',
                    dataIndex: 'count',
                    ellipsis: true,
                    align: 'center'
                }
            ]
        }
    },
    filters: {
    },
    created() {
        this.getList()
    },
    computed: {
    },
    watch: {
    },
    methods: {
        getList() {
            this.loading = true
            selectAllPlaylist({}).then(response => {
                this.list = response.data
                this.loading = false
            })
        },

        
        add() {
            const selectedList = this.selectedRows;
            if (selectedList.length === 0) {
                this.$message.warning('请先选择数据');
                return;
            }
            copyPlaylist(selectedList, {targetType: this.type,targetLanguage: this.language}).then(() => {
                this.$message.success('操作成功')
                this.getList()
            })
        },

        closeDrawer() {
            this.drawerVisible = false
        },
        getCheckboxProps(list) {
            const isExisting = this.existingVideoIds.includes(list.id)
            return {
                props: {
                    disabled: isExisting
                }
            }
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParam.pageNum = 1
            this.getList()
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParam = {
            }
            this.handleQuery()
        },
        onShowSizeChange(current, pageSize) {
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        changeSize(current, pageSize) {
            this.queryParam.pageNum = current
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
            this.ids = this.selectedRows.map(item => item.id)
            this.single = selectedRowKeys.length !== 1
            this.multiple = !selectedRowKeys.length
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            var that = this
            const ids = row.id || this.ids
            if (row.id) {
                this.ids.push(row.id)
            }
            this.$confirm({
                title: '确认删除所选中数据?',
                content: '当前选中编号为' + ids + '的数据',
                onOk() {
                    const data = []
                    that.ids.map(id => data.push({ 'id': id }))
                    return delPlaylistVideo(data)
                        .then(() => {
                            that.onSelectChange([], [])
                            that.getList()
                            that.$message.success(
                                '删除成功',
                                3
                            )
                        })
                },
                onCancel() {
                    // 取消清空删除ids列表
                    that.ids = []
                }
            })
        },
    }
}
</script>
  